import { render, staticRenderFns } from "./ChannelsListTable.vue?vue&type=template&id=e465283c&"
import script from "./ChannelsListTable.vue?vue&type=script&lang=ts&"
export * from "./ChannelsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports